module.exports = "/assets/data/36af084dcae8eaaa2a86f36cd656fe2b-G21.data.json";